import FindReplacePage from './Report';
import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import routeUtils from 'util/routeUtils';
import toolFlow from 'helpers/toolFlow';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';
import {router, events} from 'lib';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.find-replace] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperFindReplaceContainer page={params.page || 0}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'tools/accounts/find-replace/:page', handler: routeUtils.requireAuth(render)}]);

class FindReplace extends React.Component {
  static displayName = 'FindReplace';

  static propTypes = {
    View: PropTypes.any.isRequired,
  };

  state = {};

  render() {
    let {View} = this.props;
    let {formatMessage} = this.props.intl;

    return (
      <div className='container'>
        <Header mainTitle={formatMessage({id: 'general.accounts'})}
                subTitle={formatMessage({id: 'tools.find.replace.data'})}
                mainTitleReturn='#tools/accounts'/>
        <View/>
      </div>
    );
  }
}

const FindReplaceContainer = toolFlow(FindReplace, Instructions, FindReplacePage);

let WrapperFindReplaceContainer = injectIntl(FindReplaceContainer);
